import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const renovateStatsPlugin = createPlugin({
  id: 'renovate-stats',
  routes: {
    root: rootRouteRef,
  },
});

export const RenovateStatsPage = renovateStatsPlugin.provide(
  createRoutableExtension({
    name: 'RenovateStatsPage',
    component: () =>
      import('./components/RenovateComponent').then(m => m.RenovateComponent),
    mountPoint: rootRouteRef,
  }),
);
